export default {
  // 設定頁面
  PunchBoardTitle: "戳戳樂-遊戲設定",
  candidatesLabel: "候選人名單",
  candidatesPlaceholder: "輸入候選名字，並以逗號(,)分隔，按下Enter新增項目，最大候選數為20人",
  candidateExists: "候選人已存在",
  maxCandidates: "候選人數量已達上限 (20)",
  clearSettings: "清空設定",
  saveSettings: "儲存設定"
}